export default "__VITE_ASSET__CSb4imbx__"